<template>
  <div
    :class="{
      'absolute left-0 top-[61px] z-10 w-full shadow-[0_8px_16px_0_rgba(0,0,0,.2)] transition-all duration-0 md:top-[62px] lg:top-[79px]': true,
      'border-www-color-primary-lighter md:border-t-2': true,
      'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
    }"
  >
    <!-- Divider in mobile view -->
    <div
      :class="{
        'divider ml-10 mr-25px border-b border-www-color-neutral-medium md:hidden': true,
      }"
    ></div>

    <div
      :class="{
        'max-h-screen overflow-y-auto overflow-x-hidden pb-20 md:max-h-[calc(100vh-72px)] md:overflow-y-auto md:pb-0': true,
      }"
    >
      <div
        :class="{
          'gap-x-gutter grid grid-cols-12 gap-y-0 sm:grid-cols-8 md:grid-cols-12': true,
        }"
      >
        <div
          :class="{
            'right-col col-span-12 h-full lg:col-span-8': true,
            'grid grid-cols-12 gap-y-0': true,
            'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
          }"
        >
          <div class="col-span-12 lg:col-span-5">
            <div
              :class="{
                'resource-center-bar flex-col items-start border-www-color-neutral-very-light': true,
                'text-www-color-white md:text-www-color-neutral-medium-dark': true,
                'bg-www-color-neutral-medium-dark py-30px pl-10 pr-5 md:bg-www-color-white md:py-6 md:pl-60px md:pr-7': true,
              }"
            >
              <div>
                <h3
                  :class="{
                    'card-title mb-3 text-sm font-bold uppercase tracking-wider md:mb-4 md:text-lg': true,
                  }"
                >
                  {{ highlightCorner.heading }}
                </h3>
                <p
                  :class="{
                    'resource-center-bar-p pb-4 text-10px font-medium leading-3 tracking-wider md:pb-18px md:text-xs md:leading-[14px]': true,
                  }"
                >
                  {{ highlightCorner.description }}
                </p>
                <GeneralLink
                  v-if="highlightCorner.link"
                  v-bind="highlightCorner.link"
                  :class="{
                    'border-3px border-www-color-primary-lighter bg-www-color-transparent text-www-color-white md:bg-www-color-white md:text-www-color-primary-lighter': true,
                    'hover:bg-www-color-primary-lighter hover:text-www-color-white focus:border-3px focus:border-www-color-accent-blue-light focus:bg-www-color-primary-lighter focus:text-www-color-primary-dark active:text-www-color-primary': true,
                    'btn-link box-border rounded border-3px px-4 text-center font-ptc-Rajdhani text-15px font-bold uppercase leading-10 transition-all duration-300 md:text-18px md:leading-46px': true,
                    'inline-block h-46px md:h-52px': true,
                  }"
                />
              </div>
            </div>
          </div>
          <!-- Divider in mobile view -->
          <div
            :class="{
              'divider col-span-12 mb-5 ml-10 mr-25px border-b border-www-color-neutral-medium md:hidden': true,
            }"
          ></div>

          <div
            class="col-span-12 grid grid-cols-12 gap-0 pl-10 md:px-70px md:py-30px md:pr-0 lg:col-span-7 xl:px-0"
          >
            <SolutionsMegaMenuColumn
              v-if="column1"
              v-bind="column1"
            />
            <SolutionsMegaMenuColumn
              v-if="column2"
              v-bind="column2"
            />
            <SolutionsMegaMenuColumn
              v-if="column3"
              v-bind="column3"
            />
          </div>
        </div>

        <div
          :class="{
            'left-col col-span-12 border-www-color-neutral-very-light md:border-t lg:col-span-4 lg:border-l lg:border-t-0': true,
          }"
        >
          <NavFeaturedCard
            v-if="props.featureData"
            :heading="featuredCard?.heading"
            :card="props.featureData"
            menu-type="solutions"
            :class="{
              'hidden md:block': true,
            }"
          />
        </div>
      </div>
      <div
        :class="{
          'bg-www-color-neutral-medium-dark md:bg-www-color-white': true,
        }"
      >
        <NavFeaturedCard
          v-if="props.featureData"
          :heading="featuredCard?.heading"
          :card="props.featureData"
          menu-type="solutions"
          :class="{
            'block md:hidden': true,
          }"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { SolutionsDropdown, CardBlogResult } from '~/sanity/types';
import NavFeaturedCard from './NavFeaturedCard.vue';
import SolutionsMegaMenuColumn from './SolutionsMegaMenuColumn.vue';
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
type PropType = SolutionsDropdown & {
  featureData?: CardBlogResult | null;
};

const props = withDefaults(defineProps<PropType>(), {
  featureData: null,
});
</script>
<style lang="scss" scoped></style>
